export const TEXT_LIST = [
  '에이젠글로벌은 제휴 기관들로부터 받은 금융 상품 정보를 전달하고\n' +
    '            있습니다.',
  '에이젠글로벌은 제공된 정보에 대해 법적인 책임을 지지 않습니다.',
  '에이젠글로벌이 제공하는 금융 정보는 참고 사항이며, 오류가 발생할 수\n' +
    '            있고 지연될 수 있습니다.',
  '에이젠글로벌의 사전 서면 동의 없이 사이트의 정보, 콘텐츠, UI 등을\n' +
    '            상업적 목적으로 사용할 수 없습니다.',
];
